// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing150({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle10
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/150/1.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/150/2.gif`}
      formFieldColor="white"
      qTitleColor="#711ff5"
      qOptionColor="blue"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/purple/applyButton.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
      eventDates={true}
    />
  );
}

export default Randing150;
